export default __webpack_public_path__ + "static/media/iron.2fb044fe.png";